import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from "@angular/material";
//import { CurrencyMaskModule } from "ng2-currency-mask";
//import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";

import { JwtModule } from "@auth0/angular-jwt";
import { AppComponent } from "./app.component";
import { coreModule } from "./core/core.module";
import { hrmModule } from "./pages/hrm/hrm.module";
import { sharedModule } from "./shared/shared.module";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { DROPZONE_CONFIG } from "ngx-dropzone-wrapper";
import { AppRoutingModule } from "./app-routing.module";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { accountModule } from "./pages/account/account.module";
import { InstituteModule } from "./pages/Institute/institute.module";
import { TranslateModule, TranslateService } from "@ngstack/translate";
import { BasicInfoModule } from "./pages/basic-information/basicInfo.module";
import { registrationModule } from "./pages/registration/registration.module";
import { ReportModule } from "./pages/report/report.module";
import { FormErrorsComponent } from "./components/form-errors/form-errors.component";
import { AngularMaterialModule } from "./pages/angular-material/angular-material.module";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { ChartsModule } from 'ng2-charts';
import { PlacementReservationModule } from "./pages/placement-reservation/placementReservation.module";
import { studentModule } from "./pages/student/student.module";


import {
  MaterialPersianDateAdapter,
  PERSIAN_DATE_FORMATS
} from "./shared/material.persian-date.adapter";
import { mainModule } from "./pages/main/main.module";
import { AlertDialogComponent } from "./components/alert-dialog/alert-dialog.component";
import { AmazingTimePickerModule } from "amazing-time-picker";
import { FinanceModule } from "./pages/finance/finance.module";
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './services/common/loader.service';
import { LoaderInterceptor } from "./interceptors/loader.interceptor";
//import { CourseSessionsComponent } from './components/course-sessions/course-sessions.component';
import { SessionsModule } from "./pages/sessions/sessions.module";
import { SubsidiaryModule } from "./pages/subsidiary/subsidiary.module";
import { subsidiaryDashboardModule } from "./pages/subsidiary-dashboard/subsidiaryDashboard.module";
import { VersionCheckService } from "./services/common/version-check.service";
import { SendSmsComponent } from './pages/management/send-sms/send-sms.component';
import { HomeComponent } from './pages/home/home.component';
import { GuidanceModule } from "./pages/guidance/guidance.module";

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: "https://httpbin.org/post",
  maxFilesize: 50,
  acceptedFiles: "image/*"
};
// export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
//   align: "right",
//   allowNegative: true,
//   decimal: ",",
//   precision: 0,
//   prefix: " ",
//   suffix: "",
//   thousands: "."
// };

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

export function setupTranslateService(service: TranslateService) {
  return () => service.load();
}

@NgModule({
  declarations: [AppComponent, FormErrorsComponent, AlertDialogComponent, LoaderComponent,
    // CourseSessionsComponent,
    SendSmsComponent,
    HomeComponent
  ],
  imports: [
    //CurrencyMaskModule,
    HttpModule,
    coreModule,
    mainModule,
    sharedModule,
    BrowserModule,
    // ChartsModule,
    accountModule,
    FinanceModule,
    DropzoneModule,
    BasicInfoModule,
    InstituteModule,
    subsidiaryDashboardModule,
    SubsidiaryModule,
    SessionsModule,
    HttpClientModule,
    HttpClientModule,
    AppRoutingModule,
    registrationModule,
    ReportModule,
    AngularMaterialModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    AmazingTimePickerModule,
    PlacementReservationModule,
    hrmModule,
    studentModule,
    GuidanceModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    TranslateModule.forRoot({
      debugMode: false,
      supportedLangs: ["fa", "en"],
      activeLang: "fa",
      translationRoot: "assets/i18n"
    }),
  ],
  entryComponents: [SendSmsComponent],
  providers: [
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateService,
      deps: [TranslateService],
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MaterialPersianDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: PERSIAN_DATE_FORMATS },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    VersionCheckService
    // { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function tokenGetter() {
  return localStorage.getItem("token");
}
